import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetChallengeClipRequest } from './get-challenge-clip-request';
import type { IGetChallengeClipResponse } from './get-challenge-clip-response';
import { getChallengeClipResponseSchema } from './get-challenge-clip-response';

export async function getChallengeClipApi({
  challengeId,
  clipId,
}: IGetChallengeClipRequest): Promise<IValidatedResponse<IGetChallengeClipResponse>> {
  return getRequest<IGetChallengeClipResponse>({
    path: `/sys/challenges/${challengeId}/clips/${clipId}`,
    schema: getChallengeClipResponseSchema,
  });
}
